import { Grid, makeStyles, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles(() => ({
  container: {
    padding: '12px 16px',
    gap: '10px',
    width: '201px',
    height: '45px',
    background: '#FEFEFE',
    border: '1px solid #E4E7EC',
    borderRadius: '8px',
    marginRight: '16px',
    marginBottom: '8px',
  },
  closeIcon: {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  },
  text: {
    width: '140px',
    height: '21px',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '140%',
    color: '#622FEE',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
const CollectionChip = (props) => {
  const classes = useStyles();

  return (
    <Grid container direction="row" className={classes.container} justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography className={classes.text}>{props.title}</Typography>
      </Grid>
      <Grid item onClick={props.handleChipClose}>
        <Close className={classes.closeIcon} />
      </Grid>
    </Grid>
  );
};

export default CollectionChip;
